import React from 'react';
import { Formik, FormikValues } from 'formik';

import Form from '@lyearn/form/src/Form/components/Form';
import FormContext from '@lyearn/form/src/Form/context/FormContext';
import { FormikSelectorContextProvider } from '@lyearn/form/src/Form/context/FormikContextSelector';
import defaultValidate from '@lyearn/form/src/Form/helper/defaultValidate';

import useMultiStepForm from '../hooks';
import MultiStepContainer from '../MultiStepContainer';
import { MultiStepFormProps } from '../types';

const MultiStepForm = <T extends FormikValues = FormikValues>(props: MultiStepFormProps<T>) => {
  const {
    sections,
    initialValues,
    disabledSections,
    setSubmitRef,
    onChange,
    formName,
    validate,
    onSubmit,
    fields,
    hideBackNavigation,
    hideNextNavigation,
    variant = 'sidebar',
  } = props;
  const { contextValue, inViewStep, setStep, onNext, onPrevious } = useMultiStepForm(props);

  return (
    <Formik
      initialValues={initialValues}
      validate={defaultValidate(fields, validate)}
      onSubmit={onSubmit}>
      <FormikSelectorContextProvider>
        <FormContext.Provider value={contextValue}>
          <Form
            className="h-full w-full"
            formName={formName ?? 'multi-step-form'}
            setSubmitRef={setSubmitRef}
            onChange={onChange}>
            <MultiStepContainer
              disabledSections={disabledSections}
              inViewStep={inViewStep}
              sections={sections}
              setStep={setStep}
              variant={variant}
              onNext={hideNextNavigation ? undefined : onNext}
              onPrevious={hideBackNavigation ? undefined : onPrevious}
            />
          </Form>
        </FormContext.Provider>
      </FormikSelectorContextProvider>
    </Formik>
  );
};

export default MultiStepForm;
